import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type StorageFileDescriptor = {
    name: string
    length: number | null
    lastModified: string | null
    contentType: string | null
}

export const getFastboundFiles = (): Promise<StorageFileDescriptor[]> => {
    return api.get('/v2/subscriptions/fastbound/files')
}

export const getFastboundFilesQueryOptions = () => {
    return queryOptions({
        queryKey: ['fastbound-files'],
        queryFn: () => getFastboundFiles(),
    })
}

type UseFastboundFilesOptions = {
    queryConfig?: QueryConfig<typeof getFastboundFiles>
}

export const useFastboundFiles = ({ queryConfig }: UseFastboundFilesOptions = {}) => {
    return useQuery({
        ...getFastboundFilesQueryOptions(),
        ...queryConfig,
    })
}

